module.exports = __webpack_public_path__ + "img/d7839e3.jpg";